import DBOperations from "src/utils/dbOperations";
import Constants from "src/utils/constants";
import Exception from "src/utils/exception";

const tableName = Constants.enums.TABLES_NAME_ENUM.ASSETS_TABLE;

let bucketName = Constants.enums.DATASTORE_BUCKET_ENUM.ATTACHMENTS;

async function createNewAsset(data) {
  try {
    return await DBOperations.insertData(tableName, data);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function updateAsset(id, data) {
  try {
    // Update the asset in the database
    let _res = await DBOperations.updateData(tableName, id, data);

    // Check if there was an error with the update
    if (_res.error) {
      return {
        error: _res.error
      };
    }

    // Return the updated asset data
    return _res.data;
  } catch (error) {
    // Handle and log any exceptions
    Exception.catchException(error);
    return {
      error: "An error occurred while updating the asset"
    };
  }
}

async function deleteAsset(id) {
  try {
    let data = {
      id,
      is_deleted: true
    };
    let _res = await DBOperations.updateData(tableName, data);
    return { data, ..._res };
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getAssets(config) {
  try {
    let _res = await DBOperations.fetchData(
      tableName,
      config.fetchDeleted,
      config.searchTxt,
      config.sortField,
      config.sortOrder,
      config.page,
      config.rows,
      config.fetchAll,
      config.queryParams
    );
    return _res.data.map((item) => item.asset_url);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  createNewAsset,
  deleteAsset,
  getAssets,
  updateAsset
};
